import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

class AuthDataBtn extends React.Component {
    constructor(props, context) {
        super(props, context);

        this.state = {
            authData: this.props.authData || '',
            hasAuthData: false
        };
    }

    shouldComponentUpdate(nextProps, nextState) {
        const curState = this.state;
        const curProps = this.props;

        if (curState.authData !== nextState.authData ||
            curState.hasAuthData !== nextState.hasAuthData ||
            curProps.authDataPanelOpened !== nextProps.authDataPanelOpened) {
            return true;
        }

        return false;
    }

    componentDidUpdate(prevProps) {
        const { authData } = this.props;
        if (authData !== prevProps.authData) {
            this.updateAuthData(authData);
        }
    }

    updateAuthData = (authData) => {
        this.setState({
            authData: JSON.stringify(authData, false, 4),
            hasAuthData: !_.isEmpty(authData)
        });
    }

    render() {
        const {
            classes,
            authDataPanelOpened
        } = this.props;

        const {
            hasAuthData
        } = this.state;

        return (
            <div className={`auth-data-btn ${classes} ${hasAuthData && 'filled'} ${authDataPanelOpened && 'opened'}`}>
                <span className="auth-data-btn_icon-holder">
                    <i className={`icon icon-alan-auth-data`} />
                </span>
            </div>
        );
    }
}

AuthDataBtn.propTypes = {
    classes: PropTypes.string,
};

export default AuthDataBtn;